import { render, staticRenderFns } from "./InputPassengersCounter.vue?vue&type=template&id=2aed98b6"
import script from "./InputPassengersCounter.vue?vue&type=script&lang=js"
export * from "./InputPassengersCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputPassengersCounterButton: require('/home/forge/farescraper.com/components/InputPassengersCounterButton.vue').default})
